import { Anchor, PageNotification, PageNotificationColorCode, SubText } from 'UI-Dash-Commons-UI';
import React from 'react';

type Props = {
    onVisibilityChange?: ( visible: boolean ) => void;
    localStorageKey: string;
    text: string;
    link?: string;
    linkText?: string;
}

const UserGrowlComponent: React.FunctionComponent<Props> = ( { onVisibilityChange, localStorageKey, text, link, linkText } ) =>
{
    return (
        <PageNotification 
            colorCode={PageNotificationColorCode.LIGHT_BLUE}
            onVisibilityChange={onVisibilityChange}
            localStorageKey={`system_growl_${localStorageKey}`}>
            <SubText>
                {text}{' '}
                {link && linkText ? <Anchor href={link} target="_blank" rel="noopener noreferrer" text={linkText} /> : null}
            </SubText>
        </PageNotification>
    );
};

export default UserGrowlComponent;
